// extracted by mini-css-extract-plugin
export default {"LabelTooltip":"Label-module__LabelTooltip--BUH7n"};